import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

interface SortDirectionSelectProps {
  value?: string;
  onChange: (e: any) => void;
}

export function SortDirectionSelect({ value, onChange }: SortDirectionSelectProps) {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel shrink>Ordenar por data</InputLabel>
      <Select
        name="select-order-direction"
        value={value || 'desc'}
        onChange={onChange}
        label="Ordenar por data"
      >
        <MenuItem value="desc">Mais recente primeiro</MenuItem>
        <MenuItem value="asc">Mais antiga primeiro</MenuItem>
      </Select>
    </FormControl>
  );
}
